
export const RecalProposalSetConstant = {
    Table: {
        PROPOSAL_SET_NAME: "Proposal Set Name",
        PROPOSAL_SET_DESC: "Proposal Set Desc.",
    },
    DtlTable: {
        COMPANY_CODE: "Company Code",
        COMPANY_TYPE: "Company Type",
        PROPOSAL_NO: "Proposal No",
        EFFECTIVE_DATE: "Effective Date",
        EXPIRY_DATE: "Expiry Date",
        CREATED_BY: "Created By",
        CREATED_DATE: "Created Date",
    },
    Title: {
        CATEGORY: "Recalculation",
        DTL_TITLE: "Proposal Set List",
        TITLE: "Proposal Set for Recalculation",
    },
}
export const recalProposalSetRequiredFieldList: string[] = [
    'proposalSetName',
];
export const recalProposalSetDtlRequiredFieldList: string[] = [
    'companyCode',
    'proposalNo',
];